module.exports = "/_next/static/images/invader-21e0d48caabf14500925611426d86736.png";